export enum ManagementStatusListEnum {
  AUTOMATICALLY_MANAGED = 'AUTOMATICALLY_MANAGED',
  MANUALLY_MANAGED = 'MANUALLY_MANAGED',
  NOT_MANAGED = 'NOT_MANAGED'
}